import axios from "axios";
import router from "../router";
import { Toast, Indicator } from "mint-ui";
import params from "../service/params";
import Router from "../util/replaceState";
//请求超时时限
axios.defaults.timeout = 10000;

//请求次数
axios.defaults.retry = 2;
//请求的间隙
axios.defaults.retryDelay = 1000;
// 添加请求拦截器
axios.interceptors.request.use(
    function(config) {
        return config;
    },
    function(error) {
        return Promise.reject(error);
    }
);
// 添加响应拦截器
axios.interceptors.response.use(
    response => {
        if (response.data) {
            if (response.data.Code == 0) {
                return response.data.Data;
            } else if (response.data.code == 0) {
                return response.data.data;
            } else if (response.data.Code == 100 || response.data.code == 100) {
                let ReUrl = window.location.href;
                router.push({
                    path: "/user",
                    query: {
                        ReUrl: ReUrl,
                        // 云助理或AI展业
                        RegType: Router.isYzl() ? 2 : 17
                    }
                });
                return;
            } else if (
                response.config.url.indexOf("/api/bind") != -1 &&
                response.data.Code == 409
            ) {
                Toast({
                    message: `手机号已被使用,如有疑问，请联系客服,${response.data.Message}`,
                    position: "bottom"
                });
            } else if (
                response.config.url.indexOf("/api/bind") != -1 &&
                response.data.Code == 403
            ) {
                Toast({
                    message: `验证码不正确,${response.data.Message}`,
                    position: "bottom"
                });
            } else if (
                response.config.url.indexOf("/api/phonebind") != -1 &&
                response.data.Code == 409
            ) {
                Toast({
                    message: `该用户已绑定手机号或该手机号已被使用, 请联系客服,${response.data.Message}`,
                    position: "bottom"
                });
            } else if (
                response.config.url.indexOf("/api/phonebind") != -1 &&
                response.data.Code == 403
            ) {
                Toast({
                    message: `验证码不正确,${response.data.Message}`,
                    position: "bottom"
                });
            } else if (
                response.config.url.indexOf("/api/login/code") != -1 &&
                response.data.Code == 403
            ) {
                Toast({
                    message: `验证码不正确,${response.data.Message}`,
                    position: "bottom"
                });
            } else if (
                response.config.url.indexOf("/api/login/token") != -1 &&
                response.data.Code == 403
            ) {
                Toast({
                    message: `登录失效, 请重新登录,${response.data.Message}`,
                    position: "bottom"
                });
            } else if (
                response.config.url.indexOf("/api/userinfo") != -1 &&
                response.data.Code == 404
            ) {
                Toast({
                    message: `用户信息不存在,${response.data.Message}`,
                    position: "bottom"
                });
            } else if (
                response.config.url.indexOf("/api/userinfo") != -1 &&
                response.data.Code == 406
            ) {
                Toast({
                    message: `身份证号码格式不正确,${response.data.Message}`,
                    position: "bottom"
                });
            } else if (
                response.config.url.indexOf("/api/userinfo") != -1 &&
                response.data.Code == 409
            ) {
                Toast({
                    message: `该身份证已被使用,${response.data.Message}`,
                    position: "bottom"
                });
            } else if (
                response.config.url.indexOf("/api/user/detail") != -1 &&
                response.data.Code == 404
            ) {
                Toast({
                    message: `用户信息不存在,${response.data.Message}`,
                    position: "bottom"
                });
            } else if (
                response.config.url.indexOf("/api/userid/openid") != -1 &&
                response.data.Code == 404
            ) {
                Toast({
                    message: `用户信息不存在,${response.data.Message}`,
                    position: "bottom"
                });
            } else if (response.data.Code == 400) {
                Toast({
                    message: `参数错误,${response.data.Message}`,
                    position: "bottom"
                });
            } else if (response.data.Code == 401) {
                let ReUrl = window.location.href;
                router.push({
                    path: "/user",
                    query: {
                        ReUrl: ReUrl,
                        RegType: 2
                    }
                });
                return;
            } else if (response.data.Code == 423) {
                Toast({
                    message: `该用户已被冻结, 请联系客服处理,${response.data.Message}`,
                    position: "bottom"
                });
            } else if (response.data.Code == 500) {
                Toast({
                    message: `服务器内部错误,${response.data.Message}`,
                    position: "bottom"
                });
            } else if (response.data.code == 1) {
                Toast({
                    message: response.data.msg,
                    position: "bottom"
                });
                return Promise.reject(response.data.data);
            } else {
                Toast({
                    message: response.data.Message,
                    position: "bottom"
                });
            }
            return Promise.reject(response.data);
        }
        return response;
    },
    //响应失败
    error => {
        Indicator.close();
        //请求超时的之后，抛出 error.code = ECONNABORTED的错误..错误信息是 timeout of  xxx ms exceeded
        if (
            error.code == "ECONNABORTED" &&
            error.message.indexOf("timeout") != -1
        ) {
            Toast({
                message: `网络超时，请稍后重试！`,
                position: "bottom"
            });
            // var config = error.config;
            // console.log(error.config)
            // config.__retryCount = config.__retryCount || 0;
            // if (config.__retryCount >= config.retry) {
            //   Toast({
            //     message:'网络超时，请稍后重试！',
            //     position:'center'
            //   })
            //   return Promise.reject(error);
            // }
            // config.__retryCount += 1;
            // var backoff = new Promise(function (resolve) {
            //   setTimeout(function () {
            //    console.log('resolve');
            //     resolve();
            //   }, config.retryDelay || 1);
            // });

            // return backoff.then(function () {
            //   return axios(config);
            // });
        } else {
            Toast({
                message: `网络开了点小差～`,
                position: "bottom"
            });
            return Promise.reject(error);
        }
    }
);


// WEBPACK FOOTER //
// ./src/service/config.js